import React from 'react';
import {
	Container,
	Footer,
	Wrapper,
	Separator,
	SectionLogo,
	ButtonContainer,
	ParagraphContainer,
} from './SummaryRisk.styles';
import { ReactComponent as ProfileRiskFile } from 'App/assets/img/ProfileRiskFile.svg';
import { Paragraph, Skeleton, tokens } from '@welbe/web-design-system';
import { useSummaryRisk } from './SummaryRisk.hooks';
import { NameAndDescription } from './components/NameAndDescription/NameAndDescription';
import { RiskFactors } from './components/RiskFactors/RiskFactors';
import { ExamsRecommendations } from './components/ExamsRecommendations/ExamsRecommendations';
import { ErrorInfo } from 'App/Components/ErrorInfo/ErrorInfo';
import { ModalFactor } from './components/ModalFactor/ModalFactor';
import { FiTrash } from 'react-icons/fi';
import { ModalDelete } from './components/ModalDelete/ModalDelete';
import { ModalConfirm } from 'App/Components/ModalConfirm/ModalConfirm';
import { ModalLinkEmployees } from './components/ModalLinkEmployees/ModalLinkEmployees';
import { IntroTutorial } from 'App/Components/IntroTutorial/IntroTutorial';
import { tutorialLinkEmployeesSteps } from './constants/tutorialLinkEmployeeSteps';
import { ModalUploadCsv } from 'App/Components/ModalUploadCsv/ModalUploadCsv';
import { JobProfileType } from 'Views/JobProfile/JobProfile.enums';
import { Button } from '@welbe/design-system';

export const SummaryRisk = () => {
	const {
		summaryJobProfile,
		isLoading,
		hasError,
		selectedRisk,
		selectedFactor,
		openModalFactor,
		openModalDelete,
		openModalDeleteConfirmation,
		openModalLinkEmployees,
		openModalLinkTutorial,
		openModalLinkCsv,
		handleFinish,
		handleEditProfile,
		handleEditRisk,
		handleOpenModalFactor,
		handleCloseModalFactor,
		handleOpenModalDelete,
		handleCloseModalDelete,
		handleDelete,
		handleCloseModalDeleteConfirmation,
		handleOpenModalLinkEmployees,
		handleCloseModalLinkEmployees,
		handleConfirmModalLinkEmployees,
		handleCloseModalLinkTutorial,
		handleSuccessModalLinkCsv,
		handleCloseModalLinkCsv,
	} = useSummaryRisk();

	return (
		<>
			<Container id="summary-risk-profile-container">
				<SectionLogo id="summary-logo">
					<ProfileRiskFile />
				</SectionLogo>
				<ParagraphContainer>
					<Paragraph
						fontSize="16px"
						fontWeight="600"
						textAlign="center"
						padding="0 5px 0px 0px"
						color={tokens.color_primary}
					>
						{summaryJobProfile.type === JobProfileType.RISK_PROFILE
							? 'Perfil de riesgo'
							: 'Áreas de exposición'}
					</Paragraph>
					{isLoading ? (
						<Skeleton width="200px" height="25px" />
					) : (
						<Paragraph
							fontSize="16px"
							fontWeight="600"
							textAlign="center"
							padding="0 5px 0px 0px"
							color={tokens.color_primary}
						>
							<>- {summaryJobProfile.name}</>
						</Paragraph>
					)}
				</ParagraphContainer>
				{hasError ? (
					<ErrorInfo />
				) : (
					<Wrapper>
						<NameAndDescription
							isLoading={isLoading}
							name={summaryJobProfile.name}
							description={summaryJobProfile.description}
							employeesCount={summaryJobProfile.employeesCount}
							handleEditProfile={handleEditProfile}
						/>
						<Separator />
						<RiskFactors
							isLoading={isLoading}
							summaryJobProfile={summaryJobProfile}
							handleEditRisk={handleEditRisk}
							handleOpenModalFactor={handleOpenModalFactor}
							handleCloseModalFactor={handleCloseModalFactor}
						/>
						<Separator />
						<ExamsRecommendations
							isLoading={isLoading}
							recommendedExams={summaryJobProfile.recommendedExams}
						/>
					</Wrapper>
				)}
			</Container>
			<Footer>
				{!hasError && (
					<a onClick={handleOpenModalDelete}>
						<Paragraph
							color={tokens.color_primary}
							width="250px"
							textAlign="center"
							cursor="pointer"
							fontWeight="500"
						>
							Eliminar perfil de puesto <FiTrash size={18} />
						</Paragraph>
					</a>
				)}
				<ButtonContainer>
					<Button variant="outline" width={'180px'} onClick={handleFinish}>
						Regresar
					</Button>
					{!hasError && (
						<Button width={'180px'} onClick={handleOpenModalLinkEmployees}>
							Vincular colaboradores
						</Button>
					)}
				</ButtonContainer>
			</Footer>
			{openModalFactor && selectedRisk && selectedFactor && (
				<ModalFactor
					onClose={handleCloseModalFactor}
					onEdit={handleEditRisk}
					summaryJobProfile={summaryJobProfile}
					selectedRisk={selectedRisk}
					selectedFactor={selectedFactor}
				/>
			)}
			{openModalDelete && (
				<ModalDelete
					name={summaryJobProfile.name}
					isLoading={isLoading}
					onClose={handleCloseModalDelete}
					onDelete={handleDelete}
				/>
			)}
			{openModalDeleteConfirmation && (
				<ModalConfirm
					height="160px"
					message="Perfil eliminado correctamente"
					onClose={handleCloseModalDeleteConfirmation}
					closeOnlyOnTheButton={false}
					centralize={true}
				/>
			)}
			{openModalLinkEmployees && (
				<ModalLinkEmployees
					onConfirm={handleConfirmModalLinkEmployees}
					onClose={handleCloseModalLinkEmployees}
				/>
			)}
			{openModalLinkTutorial && (
				<IntroTutorial
					context="job-profile"
					height="650px"
					onFinish={handleCloseModalLinkTutorial}
					items={tutorialLinkEmployeesSteps}
				/>
			)}
			{openModalLinkCsv && (
				<ModalUploadCsv
					origin="jobProfile"
					onSuccess={handleSuccessModalLinkCsv}
					onClose={handleCloseModalLinkCsv}
					isOpen={openModalLinkCsv}
				/>
			)}
		</>
	);
};
